import { render, staticRenderFns } from "./comp_ProductPage-AdditionalPaymentInfo.vue?vue&type=template&id=3a09a14a&"
import script from "./comp_ProductPage-AdditionalPaymentInfo.vue?vue&type=script&lang=js&"
export * from "./comp_ProductPage-AdditionalPaymentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports